<template>
  <div class="button-group buttons buttons-form" :class="onlyBtnSubmit && 'button-group--only-submit'">
    <VTooltip
      v-if="!hideBtnSubmit"
      :popup-text="tooltipForBtnSubmit"
      :show-tip="!!tooltipForBtnSubmit"
      tooltip-side="top"
      :class="{'w-100': btnSize === '100'}"
    >
      <VButton
        :text="textBtnConfirm"
        type="submit"
        color="primary"
        :size="btnSize"
        :loading="loading"
        :disabled="disabled || disabledBtnSubmit"
        @click.native="onConfirm"
      />
    </VTooltip>

    <VButton
      v-if="!onlyBtnSubmit"
      :text="textBtnReject"
      :size="btnSize"
      :disabled="disabled"
      @click.native="onReject"
    />

    <slot name="customBtn" />
  </div>
</template>

<script>
import VButton from '@/components/simple/button/VButton'

import { mixinButtonGroup } from '@/mixins/button/mixinButtonGroup'
import VTooltip from '@/components/ui/VTooltip.vue'

export default {
  name: 'ButtonGroup',
  components: { VTooltip, VButton },
  mixins: [mixinButtonGroup]
}
</script>
